import { StackPullRequestRunItem } from "shared/Stack/useStackPullRequests/gql";

export const getStackPullRequestLatestRun = (
  runs: StackPullRequestRunItem[]
): StackPullRequestRunItem | undefined =>
  runs.reduce<StackPullRequestRunItem | undefined>(
    (latestRun, run) => (!latestRun || run.createdAt > latestRun.createdAt ? run : latestRun),
    undefined
  );

export const getStackPullRequestSingleRun = (
  runs: StackPullRequestRunItem[]
): StackPullRequestRunItem | undefined => (runs.length === 1 ? runs[0] : undefined);

export const isStackPullRequestExpandable = (runs: StackPullRequestRunItem[]) => runs.length > 1;
